import { render, staticRenderFns } from "./EditIndexMenu.vue?vue&type=template&id=a4c49558"
import script from "./EditIndexMenu.vue?vue&type=script&lang=js"
export * from "./EditIndexMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports